import './App.css';
import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.js';
import ProtectedRoute from './components/ProtectedRoute';
import api from './api/client';
import Home from "./pages/Home"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Profile from "./pages/Profile"
import VerifyEmail from "./pages/VerifyEmail.js"
import Favorite from "./pages/Favorite.js"
import CreateCard from './pages/CreateCard'
import PictureDetail from './pages/PictureDetail'
import UserProfile from './pages/UserProfile'
import Messages from './pages/Messages'
import Notifications from './pages/Notifications'
import Basket from './pages/Basket'
import Support from './pages/Support'
import Admin from './pages/Admin'
import Search from './pages/Search'
import VerifyIdentity from './pages/VerifyIdentity'
import AccessibilitySettings from './pages/AccessibilitySettings'
import ColorBlindFilters from './components/ColorBlindFilters'

function App() {
  const { loading } = useAuth();
  const [lang, setLang] = useState( localStorage.getItem("language") || "en" );
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    async function loadLanguage() {
      try {
        const data = await api.getTranslations(lang);
        setTranslations(data);
      } catch {
        // Keep previous translations on failure
      }
    }
    loadLanguage();
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("language", lang);
  }, [lang]);

  if (loading) {
    return (
      <div className="loading-page">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <>
    <ColorBlindFilters />
    <Routes>
        {/* Public */}
        <Route path="/" element={<Home translations={translations} />} />
        <Route path="/login" element={<Login translations={translations} />} />
        <Route path="/register" element={<Register translations={translations} />} />
        <Route path="/verify" element={<VerifyEmail translations={translations} />} />
        <Route path="/picture/:publicId" element={<PictureDetail translations={translations} />} />
        <Route path="/user/:publicId" element={<UserProfile translations={translations} />} />
        <Route path="/search" element={<Search translations={translations} />} />

        {/* Protected */}
        <Route path="/profile" element={<ProtectedRoute><Profile lang={lang} setLang={setLang} translations={translations} /></ProtectedRoute>} />
        <Route path="/favorites" element={<ProtectedRoute><Favorite translations={translations} /></ProtectedRoute>} />
        <Route path="/create-card" element={<ProtectedRoute><CreateCard translations={translations}/></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><Messages translations={translations} /></ProtectedRoute>} />
        <Route path="/messages/:discussionId" element={<ProtectedRoute><Messages translations={translations} /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications translations={translations} /></ProtectedRoute>} />
        <Route path="/basket" element={<ProtectedRoute><Basket translations={translations} /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><Support translations={translations} /></ProtectedRoute>} />
        <Route path="/verify-identity" element={<ProtectedRoute><VerifyIdentity translations={translations} /></ProtectedRoute>} />
        <Route path="/accessibility" element={<ProtectedRoute><AccessibilitySettings translations={translations} /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin translations={translations} /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}

export default App;
